module.exports = __webpack_public_path__ + "img/university_oregon.f1b72df3.png";